import type { AdminSeriesSummary } from "@storyline/shared";
import { useCallback, useEffect, useState } from "react";
import { listSeries } from "@/src/series/services/series-http.service";

export const useSeriesList = () => {
	const [series, setSeries] = useState<AdminSeriesSummary[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);

	const reload = useCallback(async () => {
		setIsLoading(true);
		try {
			const data = await listSeries();
			setSeries(data.series);
			setHasError(false);
		} catch {
			setHasError(true);
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		void reload();
	}, [reload]);

	return { series, isLoading, hasError, reload };
};
